import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/cookieConsent.css';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/dismissed the cookie consent
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('cookieConsent', 'dismissed');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <p>
          By using this site, you agree to our{' '}
          <Link to="/privacy">
            Terms and Conditions
          </Link>.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-ok" onClick={handleAccept}>
            OK
          </button>
          <button className="cookie-btn cookie-dismiss" onClick={handleDismiss}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
